(() => {
  const SELECTOR = '.rougge-editorial-product-card__gallery';

  const initGallery = (gallery) => {
    if (gallery.dataset.rouggeSwipeReady === 'true') return;
    gallery.dataset.rouggeSwipeReady = 'true';

    const card = gallery.closest('.rougge-editorial-product-card');
    const images = gallery.querySelectorAll('.rougge-editorial-product-card__image');

    images.forEach((image) => {
      image.draggable = false;
    });

    if (!card || images.length < 2) return;

    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let dragged = false;
    let pointerId = null;

    const reset = () => {
      pointerId = null;
      gallery.classList.remove('is-dragging');

      window.setTimeout(() => {
        dragged = false;
      }, 80);
    };

    gallery.addEventListener('pointerdown', (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = gallery.scrollLeft;
      dragged = false;

      if (event.pointerType === 'mouse') {
        gallery.classList.add('is-dragging');
        gallery.setPointerCapture?.(event.pointerId);
      }
    });

    gallery.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
        dragged = true;
      }

      // En un teléfono el navegador hace el swipe nativo.
      // Con mouse en la vista responsive permitimos arrastrar para probarlo.
      if (event.pointerType === 'mouse' && dragged) {
        event.preventDefault();
        gallery.scrollLeft = startScrollLeft - deltaX;
      }
    });

    gallery.addEventListener('pointerup', reset);
    gallery.addEventListener('pointercancel', reset);
    gallery.addEventListener('lostpointercapture', reset);

    card.addEventListener(
      'click',
      (event) => {
        if (!dragged) return;

        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      },
      true
    );
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
// ROUGGE V3: keep the swipe dots in sync with the visible photo.
(() => {
  const bind = (gallery) => {
    if (gallery.dataset.rgDots) return;
    const dots = gallery.parentElement && gallery.parentElement.querySelectorAll('.rougge-editorial-product-card__dots i');
    if (!dots || dots.length < 2) return;
    gallery.dataset.rgDots = '1';
    let raf = 0;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      });
    }, { passive: true });
  };
  const scan = (root) => (root.querySelectorAll ? root.querySelectorAll('.rougge-editorial-product-card__gallery') : []).forEach(bind);
  const start = () => {
    scan(document);
    new MutationObserver((m) => m.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n)))).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
